import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { observer } from 'mobx-react';
import { TxpEventTypesV2 } from '../store/schema/TxpOptionState';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { updateTxpFlagV2 } from '../actions/txpOptionsActions';
import {
    TxpEventFlagsV2,
    isEventTypeEnabled,
    EventsInOptionsV2PageInOrder,
    getDialogTitleForTxpFlag,
    settingsOptions,
} from '../utils/getTxpFlagInfo';
import { TxpGriffinSettingsPayload, reloadTxpSettings } from 'owa-calendar-configuration';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import TxpSettingsEntryPoint from 'owa-calendar-configuration/lib/store/schema/TxpSettingsEntryPoint';

const styles = require('./TxpOptions.scss');

export interface TxpEventsPanelProps {
    formFlags: TxpEventTypesV2;
    txpSettings: TxpGriffinSettingsPayload;
}

@observer
export default class TxpEventsPanelV2 extends React.Component<TxpEventsPanelProps, {}> {
    private settingsOptions: IDropdownOption[];

    constructor(props: any) {
        super(props);
        reloadTxpSettings(true, TxpSettingsEntryPoint.FullSettings);
    }

    render() {
        let { formFlags, txpSettings } = this.props;
        this.settingsOptions = settingsOptions;

        return (
            <div className={styles.txpEventsPanel}>
                <Label>{strings.options_txp_addEventsTitle}</Label>
                {EventsInOptionsV2PageInOrder.map(eventType => {
                    if (!isEventTypeEnabled(eventType as TxpEventFlagsV2)) {
                        return null;
                    }

                    let selectedValue = getFallbackValueIfNull(
                        formFlags[eventType],
                        txpSettings.EntityTypeProcessorLevelSettings[eventType]
                    );
                    return (
                        <div className={styles.dropDownDiv}>
                            <Label>{getDialogTitleForTxpFlag(eventType as TxpEventFlagsV2)}</Label>
                            <Dropdown
                                selectedKey={selectedValue}
                                options={this.settingsOptions}
                                className={styles.entitySettingDropdown}
                                onChanged={this.updateFlag(eventType)}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }

    /**
     * On change handler for the options dropdown
     */
    private updateFlag = (flag: string) => (option: IDropdownOption, index?: number) => {
        const selectedValue = this.settingsOptions[index].key as number;
        updateTxpFlagV2(flag as TxpEventFlagsV2, null, selectedValue);
    };
}
